export default {
  data() {
    return {
      pageLoadStatus: 'none',

      enableComponent: false,
      animateTxt: true,
      activeTab: 1,
      aboutTabHeight: 0,
      selectedMenu: {},

      defaultComponent: 'Default',
      componentToLoad: '', /// template to load
      loadedComponent: '', /// template to load

      routeParams: {},
      fullPath: '',

      innerTemplates: {
        Default: 'Default',
      },

      currentRouteHash: '',
    }
  },

  watch: {
    // "$store.state.main.inxd": {
    //   handler: function () {
    //     // console.log(this.$store.state.main.indx);
    //     //
    //     // this.pageRoutingGetContent();
    //   }
    // },
    //
    // "$store.state.main.selected_menu.id": {
    //   handler: function () {
    //     this.pageRoutingGetContent();
    //   }
    // },

    // "$route": {
    //   immediate: true,
    //   deep: true,
    //   handler: function () {
    //     this.pageRoutingSelectMenuByPath();
    //     this.pageRoutingGetContent();
    //   }
    // },

    '$store.state.main.current_content_request_status': {
      immediate: true,
      handler: function () {
        // console.log('current_content_request_status', this.$store.state.main.current_content_request_status);
        if(this.$store.state.main.current_content_request_status === 'done') {
          this.loadNewPage();
        }
      }
    },

    // 'pageLoadStatus': function (){
    //   console.log(this.pageLoadStatus);
    //   // if(this.pageLoadStatus === 'waitContent' && this.$store.state.main.current_content_request_status === 'done') this.loadNewPage();
    // }
  },

  methods:{
    pageRoutingSelectMenuByPath(){
      if (!_.get(this.$store.state.main.indx, 'menus.0.id')) return false;
// console.log(this.getRouteParams());
      /// set route params and path
      //// GET MENU FROM PATH !!!!!!!!!!!!!!!
      this.selectedMenu = this.getMenuFromPath( this.getRouteParams() );

      this.selectedMenu.currentLayoutTemplate = this.findLayoutComponent(this.selectedMenu);

      this.$store.commit('main/setState', { key: 'selected_menu', val: this.selectedMenu });

      if (!this.selectedMenu) return false;

      this.$store.dispatch('main/getCurrentContentProto', this.selectedMenu);

      let breadCrumbs = this.getBreadCrumbs(this.selectedMenu);

      this.$store.commit('main/setStateDeep', { key: 'breadcrumbs', val: breadCrumbs });

      setTimeout(() => {
        /*this.addBodyClass(breadCrumbs);*/
      }, 0)

      this.$store.commit('main/setCurrentMenuLocalePaths');

    },

    pageRoutingGetContent(){

      if(!this.updateRouteHash() && _.get(this.$store.state.main.selected_menu, 'id'))return false;

      this.pageLoadStatus = 'started';

      this.$store.dispatch('main/getCurrentContentProto', this.$store.state.main.selected_menu);
      // console.log('page index: loaded current content');

      this.pageLoadStatus = 'waitContent';
      // console.log('pageLoadStatus: ',this.pageLoadStatus);



    },

    loadNewPage(){
      let _this = this;
      this.$store.commit('main/setState', {key: 'smart_components_load_status', val: 'active'});

      _this.pageLoadStatus = 'startChanging';
      _this.enableComponent = false;
      _this.$store.commit('main/setCurrentContentFromBuffer');
      _this.loadedComponent = _this.componentToLoad;
      _this.$store.commit('main/setState', {key: 'selected_menu', val: this.selectedMenu});




      setTimeout(() => {
        _this.enableComponent = true;
      }, 355);

      setTimeout(() => {
        _this.$store.commit('main/setState', {key: 'smart_components_load_status', val: '' });
      }, 700);


      this.pageLoadStatus = 'pageLoaded';
    },

    getRouteParams() {
      this.routeParams = {};
      let ready = false;
      let contentId = 0;

      for (let i in this.$route.params) {

        if (this.pathEndKeywords.indexOf(this.$route.params[i]) >= 0) {
          ready = this.$route.params[i];
          continue;
        }

        if (ready) {
          this.$set(this.routeParams, ready, parseInt(this.$route.params[i]));
          ready = false;
        }

      }

      this.fullPath = this.getPath();

      // this.$store.commit('setState', {key: 'routeParams', val: this.routeParams })
      // console.log(this.routeParams, this.fullPath);
      // console.log(contentId);
      return this.routeParams;

    },

    addBodyClass(breadcrumb) {
      let myBody = document.getElementsByTagName('body')[0];
      // document.body.className = document.body.className.replace("no-javascript","");
      document.body.className = '';
      // myBody.classList.remove('');
      for (let i in breadcrumb) {
        myBody.classList.add(_.get(breadcrumb[i], 'url'));
      }

    },

    /// find layout template depend on selected menu
    findLayoutComponent(selectedMenu) {

      let template = this.defaultComponent;

      if (_.get(selectedMenu, 'secondary_template') && this.$options.components[selectedMenu.secondary_template]) {
        template = selectedMenu.secondary_template;
      }

      if (parseInt(_.get(this.routeParams, 'singleview')) || parseInt(_.get(this.routeParams, 'productview'))) {
        template = this.getSingleViewTemplate(template); //_.get( this.innerTemplates, template);
      }

      console.log('loading template: ', template, '; selected menu: ', _.get(selectedMenu, 'title'), ':', _.get(selectedMenu, 'id'));
      this.componentToLoad = template;
      return template;

    },

    getSingleViewTemplate(template) {

      let singleViewTemplate = _.get(this.$store.state.main.indx, ['contentTypes', _.get(this.$store.state.main.current_content, 'primary.data.list.0.content_type'), 'settings', 'single_template']);

      // console.log(_.get(this.$store.state.main.current_content, 'primary.data.list.0.content_type'), singleViewTemplate);

      if (!singleViewTemplate && _.get(this.innerTemplates, template)) singleViewTemplate = _.get(this.innerTemplates, template);

      if (this.$options.components[singleViewTemplate]) template = singleViewTemplate;

      return template;
    },

    /** check if route updated, to prevent dublicated runs */
    updateRouteHash(){
      if(this.$route.name+'-'+JSON.stringify(this.$route.params) === this.currentRouteHash)return false;
      this.currentRouteHash = this.$route.name+'-'+JSON.stringify(this.$route.params);
      return true;
    },

  }

};
